import React from "react";
import { Button } from "@mui/material";

type Props = {
  onImageSelect: (file: File) => void;
};

const ImageUploader: React.FC<Props> = ({ onImageSelect }) => {
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      onImageSelect(file);
    }
  };

  return (
    <Button variant="outlined" component="label">
      画像を選択
      <input type="file" hidden accept="image/*" onChange={handleImageChange} />
    </Button>
  );
};

export default ImageUploader;
